/**
 * @desc 预订舱生成订舱计划
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinAdvanceMaster/createCabin`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
